import { BaseComponent } from '../../types';
import { DashboardMock } from './DashboardMock';
import { useNavigate } from 'react-router-dom';

interface OperationsContainerProps extends BaseComponent {
  children?: React.ReactNode;
}

export function OperationsContainer({
  className,
  children,
}: OperationsContainerProps) {
  const navigate = useNavigate();
  return (
    <div className={`flex flex-col gap-8 self-stretch ${className || ''}`}>
      {/* Top Row */}
      <div className="flex flex-col lg:flex-row items-center gap-8 w-full">
        {children}

        {/* Dashboard Mock - Desktop First */}
        <div className="hidden lg:block">
          <DashboardMock />
        </div>

        {/* Vertical Line */}
        <div
          className="hidden lg:block"
          style={{
            width: '4px',
            height: '359px',
            background:
              'linear-gradient(270deg, #030917 0.53%, #76BCE8 54.6%, #022844 84.71%, #032641 94.7%, #012C4A 109.19%)',
          }}
        />

        {/* Right Content Container */}
        <div
          className="w-[23rem] md:w-full lg:ml-10"
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            alignSelf: 'stretch',
            gap: '24px',
          }}
        >
          {/* Text Areas */}
          <div
            className="flex flex-col md:flex-row gap-8 w-full"
            style={{
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
            }}
          >
            {/* First Column */}
            <div
              className="flex-1"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '16px',
              }}
            >
              <h3
                style={{
                  color: 'var(--Text-Secondary, #FFF)',
                  fontFamily: 'Inter',
                  fontSize: '20px',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: 'normal',
                }}
              >
                Tek Panelden Tam Kontrol
              </h3>
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.80)',
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                Tüm süreçleri farklı sistemler arasında
                <br />
                kaybolmadan tek bir merkezden yönetin
                <br />
                ve operasyonel karmaşıklığı
                <br />
                ortadan kaldırın.
              </p>
            </div>

            {/* Second Column */}
            <div
              className="flex-1"
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'flex-start',
                gap: '16px',
              }}
            >
              <h3
                style={{
                  color: 'var(--Text-Secondary, #FFF)',
                  fontFamily: 'Inter',
                  fontSize: '20px',
                  fontStyle: 'normal',
                  fontWeight: '500',
                  lineHeight: 'normal',
                }}
              >
                Akıcı ve Kullanıcı Odaklı Deneyim
              </h3>
              <p
                style={{
                  color: 'rgba(255, 255, 255, 0.80)',
                  fontFamily: 'Inter',
                  fontSize: '16px',
                  fontStyle: 'normal',
                  fontWeight: '400',
                  lineHeight: '24px',
                }}
              >
                Kullanımı kolay arayüz ile ekiplerinizin
                <br />
                hızlı adapte olmasını sağlayın ve
                <br />
                operasyon süreçlerini
                <br />
                kesintisiz yönetin.
              </p>
            </div>
          </div>

          {/* Button */}
          <button
            onClick={() => navigate('/contact')}
            className="transition-all duration-300 hover:bg-[#025BCF] hover:shadow-[0_8px_25px_0_rgba(2,91,207,0.30)]"
            style={{
              display: 'flex',
              padding: '12px 20px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '2px',
              borderRadius: '24px',
              border: '1.5px solid #025BCF',
              background: 'transparent',
              color: 'var(--Text-White, #FFF)',
              fontFamily: 'Inter',
              fontSize: '18px',
              fontStyle: 'normal',
              fontWeight: '500',
              lineHeight: 'normal',
              cursor: 'pointer',
              alignSelf: 'flex-start',
            }}
          >
            Haydi dene
          </button>
        </div>

        {/* Dashboard Mock - Mobile */}
        <div className="block lg:hidden">
          <DashboardMock />
        </div>
      </div>
    </div>
  );
}
